import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {load} from 'state/environment/environmentActions';
import {
  selectIsEnvironmentLoaded,
  selectHasAuthority,
} from 'state/environment/environmentSelectors';
import {AUTHORITIES} from 'constants/AuthorityConstants';
export {AUTHORITIES} from 'constants/AuthorityConstants';

export class AuthoritySwitch extends React.Component {
  componentDidMount() {
    this.props.load();
  }

  render() {
    const {
      children,
      hasAuthority,
      isEnvironmentLoaded,
      lockedView = null,
    } = this.props;

    if (!isEnvironmentLoaded) return null;

    return hasAuthority ? React.Children.only(children) : lockedView;
  }
}

AuthoritySwitch.propTypes = {
  children: PropTypes.node.isRequired,
  authority: PropTypes.oneOf(Object.values(AUTHORITIES)).isRequired,
  lockedView: PropTypes.node,
};

export default connect(
  (state, {authority}) => ({
    isEnvironmentLoaded: selectIsEnvironmentLoaded(state),
    hasAuthority: selectHasAuthority(state, authority),
  }),
  {
    load,
  }
)(AuthoritySwitch);
